import styles from './Academics.module.css';

export default function Academics() {

    const streamsAndSubjects = [
        {
            stream : 'Arts',
            subjects : [
                'English', 
                'Marathi' , 
                'Environmental Studies and Water Safety', 
                'Health and Physical Education',
                'Geography',
                'Economics',
                'History',
                'Political Science'
            ]
        },
        {
            stream : 'Science',
            subjects : [
                'English', 
                'Physics' , 
                'Chemistry', 
                'Environmental Studies and Water Safety',
                'Health and Physical Education',
                'Biology / Geography',
                'Crop Production Science / Mathematics',
                'Marathi / IT',
            ]
        },
        {
            stream : 'Commerce',
            subjects : [
                'English', 
                'Marathi' , 
                'Economics', 
                'Business Organization and Management',
                'Secretarial Practice',
                'Bookkeeping and Accountancy',
                'Environmental Studies and Water Safety',
                'Health and Physical Education'
            ]
        },

    ]

    return (
        <section className={styles.AcademicsPage} id='academics'>
            <h2 className={styles.PageName}>Academics Information</h2>
            <p className={styles.sectionTitle}>Courses and Subjects</p>
            <div className={styles.streamsAndSubjects}>
                {streamsAndSubjects.map(item => {
                    return <article key={Math.random()} className={styles.subjectList}>
                        <p>
                        11th / 12th {item.stream} Stream
                        </p>
                        <ol>
                            {item.subjects.map((subject) => {
                                return <li key={Math.random()}>{subject}</li>
                            })}
                        </ol>
                    
                    </article>
                })}
            </div>
            
        </section>
    )
}